import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {captchaLoaded} from "./navigation/NavigationActions";
import {ReCaptchaAction, Settings} from "./http/protocol";


export const ReCaptcha = (props : { siteKey? : string }) => {

    const dispatch = useDispatch();

    const  loadScript = () => {
        let script = document.createElement('script')
        script.async = true;
        script.type = 'text/javascript'
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + props.siteKey
        script.addEventListener("load", ()=>{
            dispatch(captchaLoaded())
        })
        document.head.appendChild(script);

    }

    useEffect(()=>{
        loadScript();
    },[dispatch])
    return <div></div>
}
export const isReCaptchaActionEnabled  = (action : ReCaptchaAction, settings?: Settings) => {
    if(settings?.reCaptchaSettings?.enabled) {
        if(settings.reCaptchaSettings.actions?.find(a => a == action)){
            return true;
        }
    }
    return false;
}
export const executeCaptcha = (action : ReCaptchaAction, siteKey? : string) : Promise<string> => {
    let p = new Promise<string>((resolve, reject)=> {
        let c = (window as any).grecaptcha;
        if(!c) {
            reject("No captcha available in window");
        }
        try {
            c.ready(() => {
                c.execute(siteKey, { action: action }).then((token : string) =>  {
                    resolve(token);
                });
            });
        } catch (e) {
            console.log("Captcha failed",e);
            reject(e);
        }

    });
    return p;
}